import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Loader2, Search } from 'lucide-react';
import { useLookupCUI } from '@/hooks/useLookupCUI';

export function CUILookupInput({ value, onChange, onCompanyFound, placeholder, className, disabled, ...props }) {
  const { lookupCUI, loading } = useLookupCUI();

  const handleLookup = async () => {
    const result = await lookupCUI(value);
    if (result && onCompanyFound) {
      onCompanyFound(result);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleLookup();
    }
  };

  return (
    <div className="flex gap-2">
      <Input
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || 'Introduceti CUI...'}
        className={className}
        disabled={disabled}
        {...props}
      />
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={handleLookup}
        disabled={loading || !value || value.length < 4}
        className="shrink-0 h-10 w-10"
        title="Cauta firma dupa CUI"
        data-testid="lookup-cui-btn"
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}
      </Button>
    </div>
  );
}
